module.exports = __webpack_public_path__ + "static/media/close-default.fcaf7efc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/close-default.svg
// module id = 922
// module chunks = 0